import PasswordChangeRequired from "./PasswordChangeRequired";

export default PasswordChangeRequired;
